import { useEffect, useRef } from "react";
import * as journifyTrackingCarEvents from "../services/trackingCarEvents";

const toNumber = (v, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));


export default  function useTrackViewCart({
  cartItems,
  currency = "SAR",
  creativeSlot, // اختياري لو تبي تربطه بمكان الظهور
}) {
  const firedRef = useRef("");

  useEffect(() => {

    if (!Array.isArray(cartItems) || cartItems.length === 0) return;

    // منع تكرار نفس التتبع (خصوصاً في React StrictMode)
    const first = cartItems[0];
    const key = `${cartItems.length}-${first?.Slug || first?.productNo || ""}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const items = cartItems.map((car, idx) => ({
      // أهم شي: ID + Name
      item_id: toString(car?.productNo ?? car?.Slug, ""),
      item_name: toString(car?.nameEn ?? car?.modelTypesEn, ""),

      affiliation: "value",
      coupon: "value",
      discount: 0,
      index: idx,

      // Brand / Categories
      item_brand: toString(car?.brandEn, "value"),
      item_category: toString(car?.groupEn, "value"),       // مثل: RAIZE / Corolla / Camry
      item_category2: toString(car?.year, "value"),       // مثل: 2026
      item_category3: toString(car?.category, "value"),   // مثل: سيدان / SUV
      item_category4: toString(car?.carGroupID, "value"), // مثل: GR30
      item_category5: toString(car?.type, "value"),       // مثل: TN1386

      // variant ممكن تستخدم modelTypes أو type
      item_variant: toString(car?.colorNameEn, "value"),

      location_id: toString(creativeSlot, "value"),

      price: toNumber(car?.price, 0),
      quantity: 1,
    }));
   
    journifyTrackingCarEvents.trackViewCart(items, currency);

  }, [cartItems, currency, creativeSlot]);
}

